import { Reveal, Label } from "@/components/motion";

const pillars = [
  { n: "01", title: "Thoughtful Planning", text: "Every journey is shaped around your interests, pace and preferences." },
  { n: "02", title: "Curated Destinations", text: "We focus on destinations and experiences worth discovering." },
  { n: "03", title: "Personal Attention", text: "From the first conversation to the journey home, we're here to make travel effortless." },
  { n: "04", title: "Meaningful Experiences", text: "Because the best memories are rarely found in an itinerary alone." },
];

export default function Pillars() {
  return (
    <section data-testid="home-pillars" className="border-t border-mist bg-white">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-36">
        <Reveal>
          <Label>Why Urban Trail</Label>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-2xl font-serif text-4xl font-light leading-[1.02] tracking-tight text-ink sm:text-5xl">
            Travel, thoughtfully curated.
          </h2>
        </Reveal>
        <div className="mt-20 grid gap-x-12 gap-y-16 sm:grid-cols-2 lg:grid-cols-4">
          {pillars.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.1}>
              <div data-testid={`pillar-${p.n}`} className="border-t border-ink/10 pt-8">
                <span className="font-serif text-5xl font-light text-ink/15">{p.n}</span>
                <h3 className="mt-6 text-[13px] font-medium uppercase tracking-[0.24em] text-ink">
                  {p.title}
                </h3>
                <p className="mt-4 text-[15px] leading-relaxed text-steel">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
